import { Tooltip, TooltipProps } from 'antd';
import { useTranslation } from 'react-i18next';

const timeStyle = { marginRight: '1ch' };

type Props = {
    timeText: string;
    tooltipProps?: TooltipProps;
};
export default function TimeDisplayForReport({ timeText, tooltipProps = {} }: Props) {
    const { t } = useTranslation('dashboard');

    if (!timeText) return null;

    const [day, hour, minute, second] = timeText.split(':');
    if (day === '0' && hour === '0' && minute === '0' && second === '0') return <span>0</span>;

    return (
        <Tooltip
            placement="topLeft"
            title={
                <>
                    {day !== '0' && <span style={timeStyle}>{t('day', { count: +day })}</span>}
                    {hour !== '0' && <span style={timeStyle}>{t('hour', { count: +hour })}</span>}
                    {minute !== '0' && <span style={timeStyle}>{t('minute', { count: +minute })}</span>}
                    {second !== '0' && <span style={timeStyle}>{t('second', { count: +second })}</span>}
                </>
            }
            {...tooltipProps}
        >
            {day !== '0' && <span style={timeStyle}>{t('day', { count: +day })}</span>}
            {hour !== '0' && <span style={timeStyle}>{t('hour', { count: +hour })}</span>}
            {minute !== '0' && <span style={timeStyle}>{t('minute', { count: +minute })}</span>}
            {second !== '0' && <span style={timeStyle}>{t('second', { count: +second })}</span>}
        </Tooltip>
    );
}
